export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
        max: 100,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Win Percent',
        category: ['User', 'Plays'],
        description: 'Percentage of tracked plays that the user won.',
        summarise: {
            prefix: 'Won'
        },
        unit: '%'
    },
    rules: {
        linked: [],
        legacy: ['play.winpercent']
    }
}
